/* eslint-disable import/no-anonymous-default-export */
import { useEffect, useState } from "react";
import useApiRequest from "../../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../../utils/hooks/useFacility";
import { Assort } from "../../../../models/Assort";
import { GET_EXERCISE_GROUPS_DATES, GET_HUMANS_BY_DATES, GET_ZONES_BY_DATES } from "../../../../api/apiRoutes";
import { format } from "date-fns";
import { Instructor } from "../../../../models/Instructor";

export default (dateFromState: Date, dateToState: Date) => {
  const facilityIds = useFacility();
  const { get } = useApiRequest();

  const [exerciseGroups, setExerciseGroups] = useState<Assort[]>([]);
  const [zones, setZones] = useState<Assort[]>([]);
  const [humans, setHumans] = useState<Instructor[]>([]);

  const getExerciseGroups = async () => {
    const { result, isError } = await get(
      GET_EXERCISE_GROUPS_DATES(
        facilityIds,
        format(dateFromState, "yyyy-MM-dd"),
        format(dateToState, "yyyy-MM-dd"),
        "fitness"
      )
    );
    if (!isError) {
   
      setExerciseGroups(result);
    }
  };

  const getZones = async () => {
    const { result, isError } = await get(
      GET_ZONES_BY_DATES(facilityIds, format(dateFromState, "yyyy-MM-dd"), format(dateToState, "yyyy-MM-dd"), "fitness")
    );
    if (!isError) {
    
      setZones(result);
    }
  };

  const getHumans = async () => {
    const { result, isError } = await get(
      GET_HUMANS_BY_DATES(
        facilityIds,
        format(dateFromState, "yyyy-MM-dd"),
        format(dateToState, "yyyy-MM-dd"),
        "fitness"
      )
    );
    if (!isError) {
 
      setHumans(result);
    }
  };

  useEffect(() => {
    getExerciseGroups();
    getZones();
    getHumans();
    //eslint-disable-next-line
  }, []);

  return { exerciseGroups, zones, humans };
};
